import { Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./home";
import TermsAndConditions from "./terms";
import PaymentPolicy from "./paymentpolicy";
import RefundPolicy from "./refundpolicy";
import CancellationPolicy from "./CancellationPolicy";
import PrivacyPolicy from "./privacypolicy";
import CookiesPolicy from "./cookiespolicy";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/terms" element={<TermsAndConditions />} />
      <Route path="/payment-policy" element={<PaymentPolicy />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
      <Route path="/cancellation-policy" element={<CancellationPolicy />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/cookies-policy" element={<CookiesPolicy />} />
    </Routes>
  );
}

export default App;